import React, { createContext, useState, useEffect, useContext } from "react";

// Create Context
const AllgemeineDatenContext = createContext();

const getTodayStr = () => new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD in device local time

// Provider Component
export const AllgemeineDatenProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const saved = localStorage.getItem("allgemeineDaten");
    if (saved) {
      const parsed = JSON.parse(saved);
      return { ...parsed, datum: parsed.datum || getTodayStr() };
    }
    return {
      name: "",
      vorname: "",
      barcode: "",
      shopPatientId: "",
      groeße: "",
      gewicht: "",
      bmi: "",
      geburtsdatum: "",
      geschlecht: "",
      mrsa: "",
      diabSchulung: "",
      diabetestyp: "",
      dauerDiab: "",
      datum: getTodayStr(),
      fussAuswahl: "",
      shopListePatient: false,
      notShop: false
    };
  });

  // Persist to localStorage on change
  useEffect(() => {
    localStorage.setItem("allgemeineDaten", JSON.stringify(data));
  }, [data]);

  // Auto-generate barcode if not present
  useEffect(() => {
    if (!data.barcode) {
      const now = Date.now(); // 13 digits
      const random = Math.floor(Math.random() * 900) + 100; // 3 random digits
      const barcode = `${now}${random}`;
      setData((prev) => ({ ...prev, barcode }));
    }
  }, [data.barcode]);

  const clearAllgemeineDaten = () => {
    setData({
      name: "",
      vorname: "",
      barcode: "",
      groeße: "",
      gewicht: "",
      bmi: "", 
      geburtsdatum: "",
      geschlecht: "",
      mrsa: "",
      diabSchulung: "",
      diabetestyp: "",
      dauerDiab: "",
      datum: getTodayStr(),
      fussAuswahl: "",
      shopListePatient: false,
      notShop: false
    });
    localStorage.removeItem("allgemeineDaten");
  };

  return (
    <AllgemeineDatenContext.Provider
      value={{ data, setData, clearAllgemeineDaten }}
    >
      {children}
    </AllgemeineDatenContext.Provider>
  );
};

// Custom hook
export const useAllgemeineDaten = () => {
  const context = useContext(AllgemeineDatenContext);
  if (!context)
    throw new Error(
      "useAllgemeineDaten must be used within AllgemeineDatenProvider"
    );
  return context;
};
